<template>
  <div class="mt-3">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "BaseAuth",
};
</script>

<style></style>
